import type { SxProps, Theme } from '@mui/material';

export const styles = {
    root: { width: '100%' } as SxProps<Theme>,
};
